import { LINE_CHART_HEIGHT, LINE_CHART_HEIGHT_CARD, LINE_CHART_HEIGHT_MOB, LINE_CHART_WIDTH } from './constants';
import type { PaddingRatio } from './SparklineCanvas';

const STROKE_WIDTH_MOBILE = 1;
const STROKE_WIDTH_WEB = 1;

export const getSmallChartMaxHeight = (isChartInCard: boolean, isMobile: boolean): number => {
  if (isChartInCard) {
    return LINE_CHART_HEIGHT_CARD;
  }

  return isMobile ? LINE_CHART_HEIGHT_MOB : LINE_CHART_HEIGHT;
};

/**
 * Horizontal padding as a fraction of the rendered width.
 *
 * The values are kept in the historical `LINE_CHART_WIDTH` design space so the canvas
 * sparkline keeps the exact proportions the previous SVG chart had, whatever the real
 * pixel width of the cell turns out to be.
 */
export const getSmallChartPaddingRatio = (isChartInCard: boolean, isMobile: boolean): PaddingRatio => {
  if (isChartInCard) {
    return { left: 10 / LINE_CHART_WIDTH, right: 0 };
  }

  if (isMobile) {
    return { left: 0, right: 0 };
  }

  return { left: 0, right: 40 / LINE_CHART_WIDTH };
};

export const getSmallChartStrokeWidth = (isMobile: boolean): number => (
  isMobile ? STROKE_WIDTH_MOBILE : STROKE_WIDTH_WEB
);
